import React, {Component} from 'react';
import '@progress/kendo-theme-default/dist/all.css';
// import './App.css';
import categories1 from '../categories.json';
import products from '../products.json';
import categories from '../posts.json';

import { process } from '@progress/kendo-data-query';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Window } from '@progress/kendo-react-dialogs';
import pets from '../pets.json';
import Cards from '../components/Cards.jsx';

class Petgrid extends Component {

  state = {
    dropdownlistCategory: null,
    gridDataState: {
      sort: [
        { field: "ProductName", dir: "asc" }
      ],
      skip: 0,
      take: 10
    }
  }

  handleDropDownChange = (e) => {
    let newDataState = { ...this.state.gridDataState };
    console.log('ok');
    if (e.target.value.CategoryID !== null) {
      newDataState.filter = {
        logic: 'and',
        filters: [{ field: 'post', operator: 'eq', value: e.target.value.post }]
      }
      newDataState.skip = 0
    } else {
      newDataState.filter = []
      newDataState.skip = 0
    }
    this.setState({
      dropdownlistCategory: e.target.value.CategoryID,
      gridDataState: newDataState
    });
  }

  handleGridDataStateChange = (e) => {
    this.setState({gridDataState: e.dataState});
  }

  render() {
    return (
      <div className="card-container ">
        <h1></h1><h2>Search by Location</h2>  
        <p>
          <DropDownList
            data={categories}
            dataItemKey="CategoryID"
            textField="CategoryName"
            defaultItem={{CategoryID: null, CategoryName: "select location"}}
            onChange={this.handleDropDownChange}
            />
          &nbsp;  <strong>{null}</strong>
        </p>
        
        <Grid
          data={process(pets, this.state.gridDataState)}
          pageable={true}
          sortable={true}
          {...this.state.gridDataState}
          onDataStateChange={this.handleGridDataStateChange}
          style={{ height: "400px" }}>
          <GridColumn field="animals_name" title="Pet Name" />
          <GridColumn field="breeds" title="breed"  />
          <GridColumn field="contact_email" title="email"  />
          {/* <GridColumn field="animals_photos1"  title="photo" /> */}
          <GridColumn field="address_city" title="city" />
         
        
        </Grid>
      </div>
    );
  }
}

class checkboxColumn extends Component {
  render() {
    return (
        <td>
          <input type="checkbox" checked={this.props.dataItem[this.props.field]} disabled="disabled" />
        </td>
    );
  }
}

export default Petgrid;